import React, { useRef, useEffect, useState } from 'react'
import { gsap } from 'gsap';
import style from './index.module.less'
import { Link } from "gatsby"
import { useIntl } from "react-intl";
import classNames from 'classnames'
import ArrowRight from '@/images/SVG/arrow-right.svg'
import getCountry from '@/utils/getCountry.js'
const MobileSecondMenu = ({ getLinkUrl, handleShowSecondMenu, secTitle, ifSubMenuShow, setIfSubMenuShow, dontfixed, categoriesList, productsAll }) => {
  const headerRef = useRef()
  const menuRef = useRef()
  const secondProductsRef = useRef()
  const intl = useIntl()
  const region = getCountry()
  const [ifShowMoreProducts, setIfShowMoreProducts] = useState(false)
  const [currentIsOpen, setCurrentIsOpen] = useState('mostPopular')
  const [showProducts, setShowProducts] = useState('mostPopular')

  useEffect(() => {
    if (ifSubMenuShow) { 
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [ifSubMenuShow]);

  const toggleAnimation = (isOpen) => {
    const target = secondProductsRef.current;
    setCurrentIsOpen(isOpen)
    if (isOpen !== currentIsOpen) {
      const contentHeight = target.scrollHeight;
      console.log(contentHeight)
      gsap.to(target, {
        height: contentHeight > 506  ? 506 : contentHeight,
        opacity: 1,
        duration: 0.5,
        ease: 'power2.out',
      });
    } else {
      gsap.to(target, {
        height: 0,
        opacity: 0,
        duration: 0.5,
        ease: 'power2.in',
      });
    }
  };

  useEffect(() => {
    toggleAnimation(showProducts);
  }, [showProducts]);

  useEffect(() => {
    const target = secondProductsRef.current;
    const contentHeight = target.scrollHeight;
    gsap.to(target, {
      height: contentHeight,
      opacity: 1,
      duration: 0.5,
      ease: 'power2.out',
    });
  }, [ifShowMoreProducts]);

  return (
    <div className={style.menu} style={{ position: dontfixed ? "absolute" : "fixed" }} ref={headerRef}>
      <div>
        <div
          className={classNames(style.menuM, style.menuMSecond)}
          style={{borderBottom: ifSubMenuShow ? '0.5px solid rgba(0,0,0,0.2)' : 'none'}}
          ref={menuRef}>
          <ArrowRight className={style.arrowLeft} 
            onClick={() => handleShowSecondMenu()}
          />

          <div className={style.menuName}>{secTitle}</div>

          <div className={classNames(style.menuMBtn, style.menuMBtnClose)}
            onClick={() => {
              handleShowSecondMenu();
              setIfSubMenuShow(!ifSubMenuShow);
            }}
          >
            <div className={classNames(style.menuMBtnItem, style.menuMBtnItem1)}></div>
            <div className={classNames(style.menuMBtnItem, style.menuMBtnItem3)}></div>
          
          </div>
        </div>
      </div>

      <div className={style.guidesList} style={{ height: 'calc(100vh - 48px)', opacity: '1'}}>
        {/* 商品 guides 列表 */}
        <div className={style.menuMSecondList}>
          {categoriesList.map((cItem) => (
            <div className={style.menuMSecondListItem} key={cItem.id}>
              <div className={style.secondCategories}
               onClick={() => {
                  setShowProducts(cItem.key);
                  setIfShowMoreProducts(false);
                }
              }>
                <div className={style.cateName}>{cItem.title}</div>
                <ArrowRight className={classNames(style.arrowIcon, showProducts == cItem.key ? style.arrowUp : style.arrowDown )} />
              </div>

              {/* 被隐藏的商品列表 */}
              {showProducts == cItem.key && 
                <div className={style.secondCateProducts}>
                  <div 
                    ref={secondProductsRef} 
                    className={classNames(style.secondProducts, ifShowMoreProducts ? style.secondAllProducts : style.secondHidProducts)}
                    style={{height: '0', overflow: 'hidden'}}
                  >
                    {productsAll[cItem.key].map((pItem) => (
                      <Link to={getLinkUrl(pItem.link)} key={pItem.id} className={style.proLink}>
                        <div
                          className={style.secProItem}
                          >
                          <img src={pItem.img} />
                          <div className={style.proName}>{pItem.title}</div>
                          <div className={style.proDesc}>{intl.formatMessage({ id: pItem.desc })}</div>
                        </div>
                      </Link>
                    ))}
                  </div>

                  {productsAll[cItem.key].length > 4 && !ifShowMoreProducts && <div className={style.moreBtnContainer}>
                    <div className={style.moreBtn}
                      onClick={() => setIfShowMoreProducts(true)}
                    >{intl.formatMessage({id: "btn_more"})}</div>
                  </div>}
                  
                </div>
              }
            </div>
          ))}

          {region!=='jp' && region!=='kr' &&
            <Link to={getLinkUrl('/glasses/compare')} >
              <div className={style.menuMSecondListItem} style={{marginBottom: '56px'}}>
                <div className={style.secondCategories}>
                  <div className={style.cateName}>{intl.formatMessage({id: "air2.process.title13"})}</div>
                </div>
              </div>
            </Link>
          }
          
        </div>
      </div>
    </div>
  )
}

export default MobileSecondMenu
